<div class="container-fluid">
    <!-- Page Header with Action Buttons -->
    <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
        <h1 class="page-header mb-2 mb-lg-0">Miscellaneous Report</h1>

        <!-- Action Buttons -->
        <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
            <div class="d-flex flex-wrap gap-1">
                <button
                    [disabled]="this.isDisabled || !f.valid"
                    [matTooltip]="!f.valid ? 'Please fill in all required fields' : disabledButtonTooltip"
                    [matTooltipDisabled]="!this.isDisabled && f.valid"
                    style="color:#fff; background-color: #1C3F8B !important; border-color: #1C3F8B !important;"
                    mat-flat-button
                    class="me-1 mb-1"
                    (click)="validateAndOpenDialog('Send API')">Send Report</button>

                <button
                    [disabled]="this.isDisabled || !f.valid"
                    [matTooltip]="!f.valid ? 'Please fill in all required fields' : disabledButtonTooltip"
                    [matTooltipDisabled]="!this.isDisabled && f.valid"
                    style="color:#fff; background-color: #1C3F8B !important; border-color: #1C3F8B !important;"
                    mat-flat-button
                    class="me-1 mb-1"
                    (click)="validateAndOpenDialog('Update API')">Update Report</button>

                <button
                    style="color:#fff; background-color: #0AC92B !important; border-color: #0AC92B !important;"
                    mat-flat-button
                    class="me-1 mb-1"
                    (click)="openEntityComponent(MiscServiceDeductionsEntityComponent, 'deductions', 'miscservicededuction', 'create', '',
                    {
                        'week': this.week,
                        'year': this.year,
                        'misc_event': this.selectedMiscEventId || null,
                        'misc_event_title': this.selectedMiscEvent?.title || null
                    })"
                    type="button">
                    Add Deduction
                </button>

                <button style="background-color: transparent !important; border: none;"
                    (click)="onPrint()"
                    type="button"
                    mat-icon-button
                    class="me-1 mb-1"
                    matTooltip="Print misc report"
                    matTooltipPosition="below"
                    aria-label="Print misc report">
                    <mat-icon style="color: #1C3F8B;">print</mat-icon>
                </button>


                <button
                    style="color:#fff; background-color: #6c757d !important; border-color: #6c757d !important;"
                    mat-flat-button
                    class="me-1 mb-1"
                    [routerLink]="['/ami-reports']">
                    Back to list
                </button>
            </div>
        </div>
    </div>

    <app-report-nav-menu [week]="this.week" [year]="this.year" [currentReport]="this.currentReport"></app-report-nav-menu>

    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Filter
            </mat-panel-title>
            <mat-panel-description>
                <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <form (ngSubmit)="applyFilters()" #f=ngForm class="form">
            <div class="row">

                <!-- Event selector (event mode). Optional: scopes the report to
                     one misc_event occurrence; None = legacy week-based report. -->
                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field class="full-width-field">
                        <mat-label>Event</mat-label>
                        <mat-select
                            name="misc_event_selector"
                            [ngModelOptions]="{standalone: true}"
                            [ngModel]="selectedMiscEventId"
                            (selectionChange)="onMiscEventChange($event.value)">
                            <mat-option value="">None (by week)</mat-option>
                            <mat-optgroup label="Franchise Events" *ngIf="franchiseEvents.length">
                                <mat-option *ngFor="let event of franchiseEvents" [value]="event.id">{{ event.title }}</mat-option>
                            </mat-optgroup>
                            <mat-optgroup label="This Studio's Events" *ngIf="studioEvents.length">
                                <mat-option *ngFor="let event of studioEvents" [value]="event.id">{{ event.title }}</mat-option>
                            </mat-optgroup>
                        </mat-select>
                    </mat-form-field>
                    <!-- Event create/edit/delete lives in its own dialog: an
                         event is a mode/scope, not a filter. -->
                    <button type="button" mat-button color="primary" class="mb-2" (click)="openManageEventsDialog()">
                        Manage events
                    </button>
                </div>

                <!-- Package Dropdown -->
                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field class="full-width-field">
                        <mat-label>Select Misc Package... </mat-label>
                        <mat-select
                        name="field_package_code"
                        ngModel
                        required
                        #packageCodeField="ngModel"
                        (selectionChange)="applyFilters()">
                        <!-- <mat-option value="All">All</mat-option> -->
                        <mat-option
                        *ngFor="let package of this._taxonomyService.package_code"
                        [value]="package.id">{{ package.name }}
                        </mat-option>
                        </mat-select>
                        <mat-error *ngIf="packageCodeField.invalid && (packageCodeField.dirty || packageCodeField.touched)">
                            Package Code is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Date Range Filter (legacy mode only: an event selection is
                     the scope, so the payment range is hidden and cleared) -->
                <div class="col-12 col-sm-6 col-lg" [class.d-none]="selectedMiscEventId">
                    <mat-form-field>
                    <mat-label>Enter a date range (Payments)</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input name="field_date_and_time_value_start" (dateChange)="applyFilters()" ngModel matStartDate placeholder="Start date">
                        <input name="field_date_and_time_value_end" (dateChange)="applyFilters()" ngModel matEndDate placeholder="End date">
                    </mat-date-range-input>
                    <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>

                <!-- Week/year never filters this report's rows and never reaches
                     the send payload (line items carry their own receipt-date week);
                     it exists for legacy deduction matching and send gating, both of
                     which the event supersedes - so it is hidden in event mode. -->
                <app-week-year-selector
                    *ngIf="!selectedMiscEventId"
                    [initialWeek]="week"
                    [initialYear]="year"
                    [disableOnFutureWeek]="true"
                    [showNoneOption]="false"
                    weekColClass="col-12 col-sm-6 col-lg"
                    yearColClass="col-12 col-sm-6 col-lg"
                    (selectionChange)="onWeekYearChange($event)"
                    (isDisabledChange)="onSelectorDisabledChange($event)">
                </app-week-year-selector>

                <!-- Event Start/End Date Range Filter -->
                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field>
                        <mat-label>When did the event start/end? <span style="color: red;">*</span></mat-label>
                        <mat-date-range-input [rangePicker]="picker_event_start_end">
                            <input name="event_date_and_time_value_start" (dateChange)="applyFilters()" ngModel required #eventStartField="ngModel" matStartDate placeholder="Start date">
                            <input name="event_date_and_time_value_end" (dateChange)="applyFilters()" ngModel required #eventEndField="ngModel" matEndDate placeholder="End date">
                        </mat-date-range-input>
                        <mat-error *ngIf="(eventStartField.invalid || eventEndField.invalid) && ((eventStartField.dirty || eventStartField.touched) || (eventEndField.dirty || eventEndField.touched))">
                            Event start and end dates are required
                        </mat-error>
                        <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
                        <mat-datepicker-toggle matSuffix [for]="picker_event_start_end"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker_event_start_end></mat-date-range-picker>
                    </mat-form-field>

                </div>

                <div class="col-12 col-sm-6 col-lg">
                    <p>Event Expenses: {{ this.totalEventExpenses | studioCurrency }}</p>
                    <input class="d-none" [ngModel]="totalEventExpenses" name="package_costs" matInput>

                    <p>Transportation Costs: {{ this.totalTransportationCharges | studioCurrency }}</p>
                    <input class="d-none" [ngModel]="totalTransportationCharges" name="transportation_costs" matInput>
                </div>

                <section class="section">

                    <div class="float-end bring-inline">
                        <button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear
                        </button>
                    </div>

                </section>
            </div>


            <section class="section">
            </section>

        </form>

    </mat-expansion-panel>

    <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

    <!-- Event mode with no linked packages: explain the empty table and offer
         the one-click repair instead of leaving staff at a silent dead end. -->
    <div class="alert alert-warning mt-3" *ngIf="selectedMiscEventId && eventLinkStatus && eventLinkStatus.linkedCount === 0">
        <strong>No packages are linked to this event yet.</strong>
        Receipts appear here once this event's package(s) are linked to it, payments follow the package, not the package code.
        <ng-container *ngIf="eventLinkStatus.candidates.length > 0">
            <div class="mt-2">Packages using this event's code that aren't linked to any event:</div>
            <ul class="mb-0 mt-1">
                <li *ngFor="let pkg of eventLinkStatus.candidates" class="mb-1">
                    {{ pkg.title }}
                    <button type="button" mat-stroked-button color="primary" class="ms-2"
                        [disabled]="linkingPackageId"
                        (click)="linkPackageToEvent(pkg)">Link to this event</button>
                </li>
            </ul>
        </ng-container>
        <div class="mt-2" *ngIf="eventLinkStatus.candidates.length === 0">
            To link one: Packages &rarr; Edit the package &rarr; check "This package is for a DOR" and pick this event.
        </div>
    </div>

    <!-- Custom header table that doesn't depend on data['#royalty_header_table'] -->
    <table class="mat-table cdk-table mat-sort mt-4" role="table" *ngIf="data != undefined && data['#royalty_header_table'] != undefined">
        <thead role="rowgroup">
            <tr>
                <th class="mat-header-cell">Report Type</th>
                <th class="mat-header-cell">Studio</th>
                <th class="mat-header-cell">Prepared By</th>
                <th class="mat-header-cell">Year</th>
                <th class="mat-header-cell">Week Number</th>
                <th class="mat-header-cell">Date Range</th>
            </tr>
        </thead>
        <tr>
            <td class="mat-row">Miscellaneous Report</td>
            <td class="mat-row">{{ currentStudio }}</td>
            <td class="mat-row">{{ this._authService.current_user?.name || 'System' }}</td>
            <td class="mat-row">{{ selectedMiscEventId ? '-' : year }}</td>
            <td class="mat-row">{{ selectedMiscEventId ? '-' : week }}</td>
            <td class="mat-row">
                {{ getReportPeriodStart() }} -
                {{ getReportPeriodEnd() }}
            </td>
        </tr>
    </table>



    <div class="table-container">

        <table mat-table #displayTable [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mt-4">

            <!-- field_sale_date Column -->
            <ng-container matColumnDef="field_sale_date">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_sale_date">
                    Date
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container>{{ reportDateService.formatDate(element.field_date_and_time) }}</ng-container>
                </td>
            </ng-container>

            <!-- field_student Column -->
            <ng-container matColumnDef="field_student">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_student">
                    Participants
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container>{{ element.field_student }}</ng-container>
                </td>
            </ng-container>

            <!-- field_instructor_percentages Column -->
            <ng-container matColumnDef="field_instructor_percentages">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_instructor_percentages">
                    Teacher
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container>{{ element.field_first_name }} {{ element.field_last_name }}</ng-container>
                </td>
            </ng-container>

            <!-- field_enrollment_total_price Column -->
            <!-- <ng-container matColumnDef="field_enrollment_total_price">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_enrollment_total_price">
                    Total Charges Due
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container>{{ element?.field_enrollment_total_price ? '$' + element?.field_enrollment_total_price : '' }}</ng-container>
                </td>
            </ng-container> -->

            <!-- field_total_payments_made Column -->
            <ng-container matColumnDef="field_total_payments_made">
                <th mat-header-cell *matHeaderCellDef class="text-end" sortActionDescription="Sort by field_total_payments_made">
                    Amount of Payment
                </th>
                <td mat-cell *matCellDef="let element" class="text-end">
                    <ng-container>{{ element.field_gross_tuition | studioCurrency }}</ng-container>
                </td>
            </ng-container>

            <!-- field_total_payments_made Column -->
            <ng-container matColumnDef="field_enrollment_package_name">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_field_enrollment_package_nametotal_payments_made">
                    Package Name
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container>{{element.field_enrollment_package_name}}</ng-container>
                </td>
            </ng-container>

            <!-- field_sps_code Column -->
            <ng-container matColumnDef="field_sps_code">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_sps_code">
                    SPS Code
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container>{{ element.field_sps_code }}</ng-container>
                </td>
            </ng-container>

            <!-- field_package_code Column -->
            <!-- <ng-container matColumnDef="field_package_code">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_package_code">
                                Package Code
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container>{{ element.field_package_code }}</ng-container>
                </td>
            </ng-container> -->

            <!-- payment_id Column -->
            <ng-container matColumnDef="payment_id">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by payment_id">
                    Reciept #
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container>{{ element.payment_id }}</ng-container>
                </td>
            </ng-container>

            <!-- total_charges_due Column -->
            <ng-container matColumnDef="total_charges_due">
                <th mat-header-cell *matHeaderCellDef class="text-end" sortActionDescription="Sort by total_charges_due">
                    Total Charges Due<!-- Gross Tuition -->
                </th>
                <td mat-cell *matCellDef="let element" class="text-end">
                    <!-- <ng-container>${{ element.field_enrollment_total_price - element.field_total_payments_made }}</ng-container> -->
                    <ng-container>{{ element.field_enrollment_total_price | studioCurrency }}</ng-container>
                </td>
            </ng-container>


            <!-- REPLACE Column -->
            <!-- <ng-container matColumnDef="REPLACE">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by REPLACE">
            REPLACE
        </th>
        <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.REPLACE">{{ element.REPLACE }}</ng-container>
        </td>
        </ng-container> -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <!-- Totals Table  -->
        <table class="mat-table cdk-table mat-sort mt-4" role="table"
            *ngIf="data != undefined">
            <thead role="rowgroup">
                <tr>
                    <!-- <th class="mat-header-cell">Total</th> -->
                    <th class="mat-header-cell">Lesson Count</th>
                    <th class="mat-header-cell text-end">Total Price</th>
                    <th class="mat-header-cell text-end">Cash</th>
                    <th class="mat-header-cell text-end">Misc Services</th>
                    <th class="mat-header-cell text-end">Subject to Royalty</th>
                    <th class="mat-header-cell text-end">Sundry</th>
                    <th class="mat-header-cell text-end">Total Receipts</th>
                </tr>
            </thead>
            <tr>
                <!-- Calculate totals from the dataSource -->
                <td class="mat-row">{{ dataSource?.data?.length || 0 }}</td>
                <td class="mat-row text-end">{{ totalChargesDueMiscReport | studioCurrency }}</td>
                <td class="mat-row text-end">{{ totalPaymentsMadeMiscReport | studioCurrency }}</td>
                <td class="mat-row text-end">{{ 0 | studioCurrency }}</td>
                <td class="mat-row text-end">{{ totalSubjectToPercentage | studioCurrency }}</td>
                <td class="mat-row text-end">{{ 0 | studioCurrency }}</td>
                <td class="mat-row text-end">{{ totalPaymentsMadeMiscReport | studioCurrency }}</td>
            </tr>
        </table>

        <!-- Totals Summary Table  -->
        <mat-card>
            <mat-card-title>
            Deductions & Summary
            </mat-card-title>

            <mat-card-content>

                <ng-container *ngIf="this.miscServiceDeductions?.[0] == undefined">
                    <!-- <div class="row"> -->
                        <!-- <p class="">Please add a deduction.</p> -->
                    <!-- </div> -->
                </ng-container>

                <table class="mat-table cdk-table mat-sort mt-4" role="table"
                *ngIf="this.miscServiceDeductions != undefined && this.miscServiceDeductions[0] != undefined">
                    <thead role="rowgroup">
                        <tr>
                            <th class="mat-header-cell">ID</th>
                            <th class="mat-header-cell">Name</th>
                            <th class="mat-header-cell">Week # / Year</th>
                            <th class="mat-header-cell">Event Expenses</th>
                            <th class="mat-header-cell">Transportation Costs</th>
                            <th class="mat-header-cell">&nbsp;</th>
                        </tr>
                    </thead>

                    <tr *ngFor="let deduction of this.miscServiceDeductions;">
                        <td class="mat-row">{{ deduction.id?.[0]?.value }}</td>
                        <td class="mat-row">{{ deduction.title?.[0]?.value }}</td>
                        <td class="mat-row">{{ deduction.field_week_report_number?.[0]?.value | json }} / {{ deduction.field_year_report_number?.[0]?.value }}</td>
                        <td class="mat-row">{{ deduction.field_event_expenses?.[0]?.value | json }}</td>
                        <td class="mat-row">{{ deduction.field_transportation_cost?.[0]?.value }}</td>
                        <td>
                            <button
                            mat-stroked-button
                            (click)="openEntityComponent(MiscServiceDeductionsEntityComponent, 'deductions', 'miscservicededuction', 'edit', deduction.id?.[0]?.value)"
                            mat-button>
                                Edit
                            </button>
                        </td>
                    </tr>
                </table>

                <table id="deductionSummaryTable" class="mat-table cdk-table mat-sort mt-4" role="table">
                    <thead role="rowgroup">
                        <tr>
                            <th class="mat-header-cell"></th>
                            <th class="mat-header-cell"></th>
                            <th class="mat-header-cell">Total Charges Due</th>
                            <th class="mat-header-cell">Amount of Payment</th>
                            <th class="mat-header-cell"></th>
                        </tr>
                    </thead>

                    <tr>
                        <td class="mat-row"></td>
                        <td class="mat-row">TOTALS:</td>
                        <td class="mat-row text-end">{{ totalChargesDueMiscReport | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ totalPaymentsMadeMiscReport | studioCurrency }}</td>
                    </tr>

                    <tr>
                        <td>Attach Substantiating Detail per Policy Release #460</td>
                        <td colspan="2" class="text-center mat-row"><b>(D-O-R ONLY) DEDUCT</b></td>
                        <td class="mat-row"></td>
                    </tr>

                    <tr>
                        <td style="width: 50%;" class="mat-row" rowspan="5">I have checked this statement and certify that it is correct and complete.  I also certify that non of the above listed enrollments or payments resulted in a violation of the Arthur Murray International, Inc. Dollar Limitation Policy or limitations set by other regulatory agencies.  I further certify that all the above have been enrolled on Arthur Murray International, Inc. approved student enrollment agreements.</td>
                    </tr>

                    <!-- TRANSPORTATION CHARGES -->
                    <tr>
                        <td class="mat-row">TRANSPORTATION CHARGES</td>
                        <td class="mat-row text-end">{{ this.totalTransportationCharges | studioCurrency }}</td>
                        <td class="mat-row"></td>
                    </tr>

                    <!-- EXPENSES -->
                    <tr>
                        <td class="mat-row">EVENT EXPENSES</td>
                        <td class="mat-row text-end">{{ this.totalEventExpenses | studioCurrency }}</td>
                        <td class="mat-row"></td>
                    </tr>

                    <!-- LESS TOTAL DEDUCTIONS -->
                    <tr>
                        <td class="mat-row text-center" colspan="2">LESS TOTAL DEDUCTIONS</td>
                        <td class="mat-row text-end">{{ totalDeductions | studioCurrency }}</td>
                    </tr>

                    <!-- TOTAL SUBJECT TO PERCENTAGE To Percentage -->
                    <tr>
                        <td class="mat-row text-center" colspan="2">TOTAL SUBJECT TO PERCENTAGE</td>
                        <td class="mat-row text-end">{{ this.totalSubjectToPercentage | studioCurrency }}</td>
                    </tr>

                    <!-- Royalty AMT Due -->
                    <tr>
                        <td class="mat-row"></td>
                        <td class="mat-row">Royalty Amount Due At</td>
                        <td class="mat-row">{{ this.royaltyPercentage }}%</td>
                        <td class="mat-row text-end">{{ this.royaltyAmountDue | studioCurrency }}</td>
                    </tr>

                    <!-- Less Fees Already Paid -->
                    <tr>
                        <td class="mat-row"></td>
                        <td class="mat-row text-center" colspan="2">LESS FEES ALREADY PAID (-)</td>
                        <td class="mat-row text-end">{{ lessFeesAlreadyPaid | studioCurrency }}</td>
                    </tr>

                    <!-- Net Due -->
                    <tr>
                        <td class="mat-row"></td>
                        <td class="mat-row text-center" colspan="2">NET DUE ** or (CREDIT DUE)</td>
                        <td class="mat-row text-end">{{netDueOrCreditDue | studioCurrency}}</td>
                    </tr>

                    <!-- ADDITIONAL AMOUNT DUE -->
                    <!-- <tr>
                        <td class="mat-row">ADDITIONAL AMOUNT DUE</td>
                        <td class="mat-row">0</td>
                    </tr> -->
                </table>
            </mat-card-content>
        </mat-card>


        <ng-container *ngIf="!(dataSource?.data?.length)">
            <div>
                Please select criteria to generate a report.
            </div>
        </ng-container>

        <!-- No paginator: the REST export display returns all matching line items in
             a single response (pager: none), so every row shows and the totals below
             sum across the entire result set. -->


    </div>
</div>
